import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../utils/common";

const Table = ({ setEdit, non_confirming_workdetails }) => {
  const data = non_confirming_workdetails?.data || [];

  const [currentPage, setCurrentPage] = useState(
    non_confirming_workdetails?.current_page || 1,
  );

  const totalPages = non_confirming_workdetails?.total_pages || 1;

  const perPage = non_confirming_workdetails?.per_page || data?.length || 0;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Date</th>
                <th>Record No.</th>
                <th>Date Raised</th>
                <th>Dept./Area</th>
                <th>Non-Conformity Statement</th>
                <th>Clause / Document Violated</th>
                <th>Remark</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {data.length ? (
                data.map((row, index) => (
                  <tr key={row.id}>
                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                    {/* <td>
                      {row.updatedAt
                        ? new Date(row.updatedAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "---"}
                    </td> */}
                    <td>{formatDate(row.createdAt) || "-"}</td>
                    <td>{row.record_no}</td>
                    <td>
                      {row.date_raised
                        ? new Date(row.date_raised).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )
                        : "---"}
                    </td>
                    <td>{row.Department?.name || "---"}</td>
                    <td>{row.non_conformity_statement}</td>
                    <td>{row.clause}</td>
                    <td>{row.remark || "---"}</td>

                    <td
                      className={
                        row.Non_Confirming_Work_Status?.name
                          ?.toLowerCase()
                          .includes("pending")
                          ? "status_pending"
                          : "status_completed"
                      }
                    >
                      {row.Non_Confirming_Work_Status?.name}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * perPage + 1} To{" "}
            {Math.min(
              currentPage * perPage,
              non_confirming_workdetails?.total || 0,
            )}{" "}
            Of {non_confirming_workdetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Table;
